(() => {
  'use strict';

  const initHeader = section => {
    if (!section || section.dataset.seqHeaderReady === 'true') return;
    section.dataset.seqHeaderReady = 'true';

    const headerBar = section.querySelector('[data-seq-header-bar]');
    const openButton = section.querySelector('[data-seq-menu-open]');
    const mobileMenu = section.querySelector('[data-seq-mobile-menu]');
    const closeButtons = section.querySelectorAll('[data-seq-menu-close]');
    const menuLinks = section.querySelectorAll('[data-seq-menu-link]');
    const megaItems = Array.from(section.querySelectorAll('[data-seq-mega-item]'));
    const mobileGroups = Array.from(section.querySelectorAll('[data-seq-mobile-group]'));
    let megaCloseTimer = null;

    const updateHeaderShadow = () => {
      if (!headerBar) return;
      headerBar.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    const closeMegaMenus = ({ restoreFocus = false } = {}) => {
      window.clearTimeout(megaCloseTimer);

      megaItems.forEach(item => {
        const trigger = item.querySelector('[data-seq-mega-trigger]');
        const panel = item.querySelector('[data-seq-mega-panel]');
        const wasOpen = item.classList.contains('is-open');

        item.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
        panel?.setAttribute('aria-hidden', 'true');

        if (restoreFocus && wasOpen) trigger?.focus();
      });

      headerBar?.classList.remove('is-mega-open');
    };

    const openMegaMenu = item => {
      if (!item || window.matchMedia('(max-width: 1049px)').matches) return;

      megaItems.forEach(other => {
        if (other === item) return;
        other.classList.remove('is-open');
        other.querySelector('[data-seq-mega-trigger]')?.setAttribute('aria-expanded', 'false');
        other.querySelector('[data-seq-mega-panel]')?.setAttribute('aria-hidden', 'true');
      });

      const trigger = item.querySelector('[data-seq-mega-trigger]');
      const panel = item.querySelector('[data-seq-mega-panel]');
      item.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
      panel?.setAttribute('aria-hidden', 'false');
      headerBar?.classList.add('is-mega-open');
    };

    megaItems.forEach(item => {
      const trigger = item.querySelector('[data-seq-mega-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', event => {
        event.preventDefault();
        const isOpen = item.classList.contains('is-open');
        if (isOpen) closeMegaMenus();
        else openMegaMenu(item);
      });

      item.addEventListener('mouseenter', () => {
        window.clearTimeout(megaCloseTimer);
        openMegaMenu(item);
      });

      item.addEventListener('mouseleave', () => {
        megaCloseTimer = window.setTimeout(() => closeMegaMenus(), 120);
      });

      item.addEventListener('focusin', () => {
        window.clearTimeout(megaCloseTimer);
        openMegaMenu(item);
      });
    });

    const closeMobileGroups = except => {
      mobileGroups.forEach(group => {
        if (group === except) return;
        const toggle = group.querySelector('[data-seq-mobile-group-toggle]');
        const panel = group.querySelector('[data-seq-mobile-group-panel]');
        group.classList.remove('is-open');
        toggle?.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    };

    mobileGroups.forEach(group => {
      const toggle = group.querySelector('[data-seq-mobile-group-toggle]');
      const panel = group.querySelector('[data-seq-mobile-group-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', () => {
        const nextOpen = !group.classList.contains('is-open');
        closeMobileGroups(group);
        group.classList.toggle('is-open', nextOpen);
        toggle.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
        panel.hidden = !nextOpen;
      });
    });

    const openMobileMenu = () => {
      closeMegaMenus();
      section.classList.add('is-menu-open');
      document.body.classList.add('seq-menu-open');
      openButton?.setAttribute('aria-expanded', 'true');
      mobileMenu?.setAttribute('aria-hidden', 'false');
      section.querySelector('[data-seq-menu-close]')?.focus();
    };

    const closeMobileMenu = ({ restoreFocus = false } = {}) => {
      section.classList.remove('is-menu-open');
      document.body.classList.remove('seq-menu-open');
      openButton?.setAttribute('aria-expanded', 'false');
      mobileMenu?.setAttribute('aria-hidden', 'true');
      closeMobileGroups();
      if (restoreFocus) openButton?.focus();
    };

    openButton?.addEventListener('click', openMobileMenu);
    closeButtons.forEach(button => button.addEventListener('click', () => closeMobileMenu({ restoreFocus: true })));
    menuLinks.forEach(link => link.addEventListener('click', () => {
      closeMegaMenus();
      closeMobileMenu();
    }));

    document.addEventListener('click', event => {
      if (!section.contains(event.target)) closeMegaMenus();
    });

    document.addEventListener('focusin', event => {
      if (!section.contains(event.target)) closeMegaMenus();
    });

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;

      if (section.classList.contains('is-menu-open')) {
        closeMobileMenu({ restoreFocus: true });
        return;
      }

      closeMegaMenus({ restoreFocus: true });
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 1050px)').matches && section.classList.contains('is-menu-open')) {
        closeMobileMenu();
      }
      if (window.matchMedia('(max-width: 1049px)').matches) closeMegaMenus();
    });

    updateHeaderShadow();
    window.addEventListener('scroll', updateHeaderShadow, { passive: true });
  };

  const initAll = root => {
    (root || document).querySelectorAll('[data-seq-site-header]').forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
